import { render } from "./AddLevel.vue?vue&type=template&id=5271a49a"
import script from "./AddLevel.vue?vue&type=script&lang=js"
export * from "./AddLevel.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__